import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import SearchableSelect from "./SearchableSelect"

const FilterBar = ({ filters, options, partnerFilter, loading, onChange }) => {
  const set          = (key, value) => onChange({ ...filters, [key]: value })
  const one          = (key, id)    => set(key, id ? [id] : [])
  const value        = (key)        => (filters[key] || [])[0] || ""
  const fieldAnswers = filters.field_answers || {}

  const pickField = (id, picked) => {
    const next = { ...fieldAnswers }
    if (picked) next[id] = picked
    else delete next[id]
    set("field_answers", next)
  }

  const years = (options.years || []).map((year) => ({ id: year, name: year }))

  return (
    <div className="px-7 py-3 flex flex-wrap items-center gap-2">
      <FontAwesomeIcon icon="filter" className="w-3 h-3 text-slate-400" />

      {partnerFilter && (
        <SearchableSelect
          options     = {partnerFilter.options}
          value       = {filters.partner || ""}
          placeholder = {partnerFilter.all_label}
          clearable   = {partnerFilter.all}
          onChange    = {(id) => set("partner", id || "")}
        />
      )}

      <SearchableSelect
        options     = {years}
        value       = {filters.year || ""}
        placeholder = {filters.year || ""}
        clearable   = {false}
        onChange    = {(id) => set("year", id)}
      />

      <label className="inline-flex items-center gap-1.5 text-[12.5px] text-slate-600 bg-white border border-slate-200 rounded-lg h-8 px-2.5">
        <input type="checkbox" checked={!!filters.rolling} onChange={(e) => set("rolling", e.target.checked)} />
        {I18n.t("contracts_dashboard.filters.rolling")}
      </label>

      <SearchableSelect
        options     = {options.clients || []}
        value       = {value("client_ids")}
        placeholder = {I18n.t("contracts_dashboard.filters.all_clients")}
        onChange    = {(id) => one("client_ids", id)}
      />

      <SearchableSelect
        options     = {options.categories || []}
        value       = {value("category_ids")}
        placeholder = {I18n.t("contracts_dashboard.filters.all_categories")}
        onChange    = {(id) => one("category_ids", id)}
      />

      <SearchableSelect
        options     = {options.formulas || []}
        value       = {value("formula_ids")}
        placeholder = {I18n.t("contracts_dashboard.filters.all_formulas")}
        onChange    = {(id) => one("formula_ids", id)}
      />

      {(options.fields || []).map((field) => (
        <SearchableSelect
          key         = {field.id}
          options     = {field.options || []}
          value       = {fieldAnswers[field.id] || ""}
          placeholder = {field.name}
          onChange    = {(picked) => pickField(field.id, picked)}
        />
      ))}

      {(filters.client_ids?.length || filters.category_ids?.length || filters.formula_ids?.length ||
        Object.keys(fieldAnswers).length) ? (
        <button type="button"
                className="text-[12.5px] text-slate-500 hover:text-slate-800 underline"
                onClick={() => onChange({ year: filters.year, rolling: filters.rolling, partner: filters.partner })}>
          {I18n.t("contracts_dashboard.filters.reset")}
        </button>
      ) : null}

      {loading && (
        <span className="ml-auto inline-flex items-center gap-2 text-[12px] text-slate-500">
          <span className="w-3 h-3 border-2 border-slate-200 border-t-blue-500 rounded-full animate-spin" />
          {I18n.t("contracts_dashboard.filters.loading")}
        </span>
      )}
    </div>
  )
}

export default FilterBar
